<script setup="">
import { ChevronRightIcon } from "lucide-vue-next";

import Accordion from "@/Components/Accordion.vue";
import AccordionItem from "@/Components/AccordionItem.vue";

import RelationActionButtonPartial from "@campaign-js/Components/Partials/RelationActionButtonPartial.vue";
import RelationFooterPartial from "@campaign-js/Components/Partials/RelationFooterPartial.vue";
import RelationIndexPartial from "@campaign-js/Components/Partials/RelationIndexPartial.vue";
import RelationLinkPartial from "@campaign-js/Components/Partials/RelationLinkPartial.vue";
import RelationQuickMenuPartial from "@campaign-js/Components/Partials/RelationQuickMenuPartial.vue";
import RelationSocialPartial from "@campaign-js/Components/Partials/RelationSocialPartial.vue";
import RelationTitlePartial from "@campaign-js/Components/Partials/RelationTitlePartial.vue";

defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const items = [
  {
    title: "캠페인 프로필",
    component: RelationTitlePartial
  },
  {
    title: "첫 화면",
    component: RelationIndexPartial
  },
  {
    title: "메뉴",
    component: RelationLinkPartial
  },
  {
    title: "퀵 버튼",
    component: RelationQuickMenuPartial,
    tooltip: "퀵 버튼은 캠페인의 오른쪽에 고정되어 있는 버튼입니다."
  },
  {
    title: "플로팅 버튼",
    component: RelationActionButtonPartial,
    tooltip: "플로팅 버튼은 캠페인 하단에 큰 ㅂ"
  },
  {
    title: "SNS 링크",
    component: RelationSocialPartial
  },
  {
    title: "푸터 정보",
    component: RelationFooterPartial
  }
];
</script>

<template>
  <Accordion class="divide-y" :active-index="0">
    <AccordionItem v-for="(item, index) in items" :key="index" class="p-6">
      <template #trigger="{ isActive, open }">
        <div class="flex cursor-pointer items-center justify-between" @click="open">
          <span class="font-bold text-700">{{ item.title }}</span>
          <ChevronRightIcon :class="isActive && 'rotate-90 transform'" class="h-4 w-4 transition-transform ease-in-out text-600" />
        </div>
      </template>

      <div class="mt-4 space-y-4">
        <component :is="item.component" :campaign="campaign" :update="update" />
      </div>
    </AccordionItem>
  </Accordion>
</template>
